import { Button, Divider, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import { useNavigate } from 'react-router';
import { useGateMainContext } from './GateMainContext';
import { AdminPanelSettingsOutlined, Logout, SettingsSystemDaydreamOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface UsersPopupProps {
    showChangeTenantDialog: () => void;
}

export default function UsersPopup(props: UsersPopupProps) {
    const { showChangeTenantDialog } = props;
    const navigate = useNavigate();
    const { userData, branding } = useGateMainContext();
    // const { initials, userName, userSurname, tenantName, userEmail, isAdmin, canCreateUsers, canCreateTenants } = useUserInfoStore();
    const { t } = useTranslation();

    const logout = () => {
        // Keep the user on the tenant's branded login page after logout when a slug exists,
        // so the brand experience persists; otherwise fall back to the default login.
        const slug = branding?.urlSlug;
        localStorage.removeItem('token');
        navigate(slug ? `/login/${slug}` : '/');

        window.parent.postMessage('logout', '*');
    }
    return (
        <div style={{ minWidth: '320px' }}>
            <div style={{ margin: '10px', background: 'white', borderRadius: '8px' }}>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '30%' }}>
                        <div className='user-button' style={{ marginLeft: 40, marginTop: 40 }}>{userData?.initials}</div>

                    </div>
                    <div style={{ width: '70%' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', margin: '32px 12px 12px 12px' }}>
                            <Typography fontWeight={'bold'}>{userData?.firstName}{' '}{userData?.lastName}</Typography>
                            <Typography fontSize={14} color='action'>{userData?.email}</Typography>
                            <Typography fontWeight='bold' color='primary'>{userData?.tenantName}</Typography>
                            <Button variant='outlined' sx={{ margin: '20px', fontWeight: 'bold' }} onClick={() => { navigate('/user'); }}>{t('UsersPopup.AccountAdministration')}</Button>
                        </div>
                    </div>
                </div>
                <Divider sx={{ bgcolor: "primary.main" }} />
                <div>
                    <Button disabled={!userData?.isAdmin}  color="secondary" startIcon={<AdminPanelSettingsOutlined />} sx={{ paddingRight: "12px", justifyContent: "flex-start", width: '100%', fontWeight: 'bold', padding: '32px' }} onClick={() => {
                        navigate('/admin');
                    }}>
                        {t('UsersPopup.Admin')}
                    </Button>
                </div>
                <Divider sx={{ bgcolor: "primary.main" }} />
                <div>
                    <Button  color="secondary" disabled={!(userData?.isTenantManager || userData?.isAdmin)} startIcon={<SettingsSystemDaydreamOutlined />} sx={{ width: "100%", paddingRight: "12px", justifyContent: "flex-start", fontWeight: 'bold', padding: '32px' }} onClick={() => {
                        navigate('/tenant');
                    }}>
                        {t('UsersPopup.TenantAdministration')}
                    </Button>
                </div>
                <Divider sx={{ bgcolor: "primary.main" }} />
                <div>
                    <Button color="secondary" startIcon={<SettingsSystemDaydreamOutlined />} sx={{ width: "100%", paddingRight: "12px", justifyContent: "flex-start", fontWeight: 'bold', padding: '32px' }} onClick={showChangeTenantDialog}>
                        {t('UsersPopup.TenantChange')}
                    </Button>
                </div>


            </div>

            <Button color="secondary" startIcon={<Logout />} onClick={logout} sx={{ width: "100%", paddingRight: "12px", fontWeight: 'bold', padding: '16px' }} >
                {t('UsersPopup.Logout')}
            </Button>
        </div>
    )
}
